import BaseView from './BaseView';
import ModuleAnimatedText from '../../classes/ModuleAnimatedText';
import HomeHero from '../../modules/HomeHero';
import HomeAbout from '../../modules/HomeAbout';
import HomeFeaturedCases from '../../modules/HomeFeaturedCases';
import HomeServices from '../../modules/HomeServices';
import CarouselArticles from '../../modules/CarouselArticles';

let view = null;

class Home extends BaseView {
	constructor(container) {
		super(container);
	}

	init() {
		const groups = new Map([
			[ModuleAnimatedText, this.container.querySelectorAll('[data-module-animated-text]')],
			[HomeHero, this.container.querySelectorAll('[data-home-hero]')],
			[HomeAbout, this.container.querySelectorAll('[data-home-about]')],
            [HomeFeaturedCases, this.container.querySelectorAll('[data-home-featured-cases]')],
			[HomeServices, this.container.querySelectorAll('[data-home-services]')],
			[CarouselArticles, this.container.querySelectorAll('[data-carousel-articles]')],
		]);

		super.createModules(groups);
	}
}

export default {
	namespace: 'home',
	beforeEnter: ({ current, next, trigger }) => {
		view = new Home(next.container);

		view.init();
	},
	afterEnter: ({ current, next, trigger }) => {
		
	},
	afterLeave: ({ current, next, trigger }) => {
		view.destroy();
		view = null;
	},
};
